import { deleteReq, postReq } from '../infra/http';
import { getReq, createUrl } from "@/infra/http";
import { PagedResponseModel, BaseResponseModel } from "@/models/core.model";
import { RunningClubAlbum, ClubAlbumPaginationFilterRequest, UpsertRunningClubExternalAlbum } from '@/models/running-club-album.model';
import { RunningClubAlbumImage, ClubAlbumImagePaginationFilterRequest } from '@/models/running-club-album-image.model';

export const getPagedRunningClubAlbums = async (input: ClubAlbumPaginationFilterRequest): Promise<PagedResponseModel<RunningClubAlbum>> => {
  return await getReq(createUrl("a/RunningClub/Album/PagedData"),
    { params: input }
  ).then((res: any) => res.data);
};

export const getRunningClubAlbum = async (id: number): Promise<BaseResponseModel<RunningClubAlbum>> => {
  return await getReq(createUrl(`a/RunningClub/Album/GetById/${id}`),
  ).then((res: any) => res.data);
};

export const getPagedRunningClubAlbumImages = async (albumId: number, input: ClubAlbumImagePaginationFilterRequest): Promise<PagedResponseModel<RunningClubAlbumImage>> => {
  return await getReq(createUrl(`a/RunningClub/Album/${albumId}/Images`),
    { params: input }
  ).then((res: any) => res.data);
};

export const deleteRunningClubAlbumImage = async (imageId: number): Promise<BaseResponseModel<null>> => {
  return await deleteReq(createUrl(`a/RunningClub/Album/Image/${imageId}`),
  ).then((res: any) => res.data);
};

export const upsertRunningClubExternalAlbum = async (input: UpsertRunningClubExternalAlbum): Promise<BaseResponseModel<RunningClubAlbum>> => {
  return await postReq(createUrl("a/RunningClub/Album/External/Upsert"),
    input
  ).then((res: any) => res.data);
};

export const deleteRunningClubAlbum = async (albumId: number): Promise<BaseResponseModel<null>> => {
  return await deleteReq(createUrl(`a/RunningClub/Album/${albumId}`),
  ).then((res: any) => res.data);
};
